import React from 'react';
import { c } from '../../utils';
import { Clickable, ClickableBaseElement } from '../Clickable';
import classes from './GridButton.module.scss';

interface Props extends React.ComponentProps<typeof Clickable> {
  size?: 'large' | 'medium' | 'small';
  active?: boolean;
  warned?: boolean;
  alerted?: boolean;
  showLabel?: boolean;
}

export const GridButton = React.forwardRef<ClickableBaseElement, Props>(
  (
    {
      className,
      size,
      active,
      warned,
      alerted,
      disabled,
      label,
      showLabel,
      children,
      ...restProps
    }: Props,
    forwardedRef,
  ) => {
    return (
      <Clickable
        className={c(
          classes.GridButton,
          size && classes[size],
          active && classes.active,
          warned && classes.warned,
          alerted && classes.alerted,
          disabled && classes.disabled,
          className,
        )}
        disabled={disabled}
        label={label}
        ref={forwardedRef}
        {...restProps}
      >
        {children}
        {showLabel && <div className={classes.label}>{label}</div>}
      </Clickable>
    );
  },
);
